// SPDX-License-Identifier: AGPL-3.0-or-later
// SPDX-FileCopyrightText: 2026 Ben Richardson <hi@ben.gy>
import type { Ctx } from '../main.ts';
import { buildInsights } from '../analysis.ts';
import { esc } from '../utils/format.ts';

export function renderInsights(root: HTMLElement, ctx: Ctx): void {
  const insights = buildInsights(ctx.data);
  root.innerHTML = `
    <div class="view-head">
      <h2>Insights</h2>
      <p class="subtitle">The findings that jump out of the 2025 result, computed straight from the data. Click a linked seat to open it.</p>
    </div>
    <div class="insight-grid">
      ${insights.map((ins) => `
        <div class="insight ${ins.severity}">
          <h4>${esc(ins.title)}</h4>
          ${ins.big ? `<div class="big">${esc(ins.big)}</div>` : ''}
          <p>${esc(ins.body)}${ins.seat ? ` <a class="seatlink" href="#" data-seat="${esc(ins.seat)}">Open ${esc(ins.seat)} →</a>` : ''}</p>
        </div>`).join('')}
    </div>`;
  root.querySelectorAll<HTMLElement>('.seatlink[data-seat]').forEach((a) => {
    a.addEventListener('click', (e) => { e.preventDefault(); ctx.openSeat(a.dataset.seat!); });
  });
}
